export type MonitoringPeriod = "1h" | "3h" | "6h" | "24h" | "broadcast";

export const MONITORING_PERIODS: readonly MonitoringPeriod[] = [
  "1h",
  "3h",
  "6h",
  "24h",
  "broadcast",
];

const HOURS: Record<Exclude<MonitoringPeriod, "broadcast">, number> = {
  "1h": 1,
  "3h": 3,
  "6h": 6,
  "24h": 24,
};

/** Окно эфира в ISO; `to: null` значит эфир ещё идёт. */
export interface BroadcastWindow {
  from: string;
  to: string | null;
}

// `to` округляется вниз до 30 с: два зрителя кабинета, опрашивающие в одной
// половине минуты, попадают в кеш бэкенда (30 с) одними и теми же границами.
// Шаг равен LIVE_REFRESH_MS хука: каждый тик меняет переменные запроса,
// иначе Apollo не перезапрашивает и реальная частота падает вдвое.
export const RANGE_STEP_MS = 30_000;

// Зеркало лимитов бэкенда `streaming.monitoring.maxRangeDays` (7) и
// `maxAgeDays` (90) из backend/config/default.yaml: окно «Этот эфир»
// подрезается здесь, чтобы длинный или старый эфир не падал с
// MONITORING_RANGE_INVALID, а показывал доступную часть данных.
export const MAX_RANGE_MS = 7 * 24 * 3_600_000;
export const MAX_AGE_MS = 90 * 24 * 3_600_000;

export function resolveMonitoringRange(
  period: MonitoringPeriod,
  now: Date,
  broadcast?: BroadcastWindow | null
): { from: string; to: string } {
  const floored = new Date(
    Math.floor(now.getTime() / RANGE_STEP_MS) * RANGE_STEP_MS
  );
  if (period === "broadcast" && broadcast) {
    const to = broadcast.to ? new Date(broadcast.to) : floored;
    // Минута запаса к границе 90 дней: запрос доходит до бэкенда позже, чем
    // посчитан здесь, и его `Date.now()` сдвигает нижнюю границу вперёд.
    const from = Math.max(
      new Date(broadcast.from).getTime(),
      to.getTime() - MAX_RANGE_MS,
      now.getTime() - MAX_AGE_MS + 60_000
    );
    if (from < to.getTime()) {
      return { from: new Date(from).toISOString(), to: to.toISOString() };
    }
  }
  const hours = period === "broadcast" ? 1 : HOURS[period];
  return {
    from: new Date(floored.getTime() - hours * 3_600_000).toISOString(),
    to: floored.toISOString(),
  };
}
